<template>
	<div class="py-4 container-fluid">
		<div class=" row">
			<div class="col-12">
				<list-do />
			</div>
		</div>
	</div>
</template>

<script>
	import ListDo from "./component/ListDo.vue";

	export default {
		name: "List DO",
		components: {
			ListDo,
		},
		data() {
			return {
				showMenu: false,
			};
		},
	};
</script>
